/** Set the page layout from its routing group.
 * Only if the layout is not already defined, to allow for explicit overrides at the page level.
 */
export default defineNuxtRouteMiddleware((to) => {
  const isPrivatePage = to.meta.groups?.includes('private');

  if (isPrivatePage && !to.meta.layout) {
    setPageLayout('private');
  }
});